import { http } from '../../config/axios'

export default function postNotificacaoFatura(notificacaoFatura: any): Promise<string> {
  return http
    .post('api/notificacao-fatura', notificacaoFatura)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post notificacaoFatura', error)
      throw Error(error.response.data)
    })
}
